import { render, staticRenderFns } from "./IbQuickTourButton.vue?vue&type=template&id=7a3c30f6"
import script from "./IbQuickTourButton.vue?vue&type=script&lang=js"
export * from "./IbQuickTourButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a3c30f6')) {
      api.createRecord('7a3c30f6', component.options)
    } else {
      api.reload('7a3c30f6', component.options)
    }
    module.hot.accept("./IbQuickTourButton.vue?vue&type=template&id=7a3c30f6", function () {
      api.rerender('7a3c30f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_v2/Button/IbQuickTourButton.vue"
export default component.exports